import updateHomepageSettingsCity from '../../../actions/siteadmin/updateHomepageSettingsCity'
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    await dispatch(updateHomepageSettingsCity(values))
}

export default submit;